'use client';

import {Icon, IconName} from '@udemy-v2/icons';
import valuePropData from './data/value-prop-module-data.json';
import styles from './value-prop-module.module.scss';

interface ValuePropModuleCardData {
    id: number;
    title1: string;
    title2?: string;
    copy: string;
    iconGlyph: string;
}

interface ValuePropModuleData {
    title: string;
    cards: ValuePropModuleCardData[];
}

/** This only mounts for ja_JP. */
export const ValuePropModule: React.FC = () => {
    const data = valuePropData as ValuePropModuleData;

    //[Removed Discovery Impression Event Tracking] @see [https://github.com/udemy/frontends-logged-out-homepage/pull/190#issuecomment-4716603085]

    return (
        <div className={styles['value-prop-module-container']}>
            <h2 className={'ud-heading-xxl'}>{data.title}</h2>

            <div className={styles['value-prop-module-cards-container']}>
                {data.cards.map(({id, title1, title2, copy, iconGlyph}) => (
                    <div key={id} className={styles['value-prop-module-card']}>
                        <div className={styles['value-prop-module-card-icon-container']}>
                            <Icon
                                glyph={iconGlyph as IconName}
                                label={false}
                                size="xlarge"
                                className={styles['value-prop-module-card-icon']}
                            />
                        </div>
                        <h3 className={styles['value-prop-module-card-title']}>
                            {title1}
                            {title2 && <br />}
                            {title2}
                        </h3>
                        <p className={styles['value-prop-module-card-copy']}>{copy}</p>
                    </div>
                ))}
            </div>
        </div>
    );
};
